import React from "react";
import AdmLessonPlanList from "../../components/AdminTabs/AdminClassTimeTable/AdmLessonPlanList";

function LessonPlanList() {
  return (
    <div>
      <AdmLessonPlanList />
    </div>
  );
}

export default LessonPlanList;
